<template>
    <div class="modal is-active"  >
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Assign Job?</p>

                <button class="delete" aria-label="close"   @click="closeBtn" ></button>
            </header>

            <section class="modal-card-body">
                <!--                  content-->
                <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
                <nav class="level">
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">Lab Order No.</p>
                            <p class="title is-size-6">{{dataToChild.idlaborder}}</p>
                        </div>
                    </div>
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">OPD No.</p>
                            <p class="title is-size-6">{{dataToChild.opd_no}}</p>
                        </div>
                    </div>

                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">Pet Name</p>
                            <p class="title is-size-6">{{dataToChild.opd_name}}</p>
                        </div>
                    </div>


                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">Owner Name</p>
                            <p class="title is-size-6">{{dataToChild.owner_name}}</p>
                        </div>
                    </div>




                </nav>

                <hr>
                <nav class="level">
                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">Date/Time</p>
                            <p class="title is-size-6">  {{customFormatDateF(dataToChild.date)}} - {{dataToChild.time}}</p>
                        </div>
                    </div>

                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">Group of /Request</p>
                            <p class="title is-size-6"> {{ dataToChild.grp_name }} </p>
                        </div>
                    </div>


                    <div class="level-item has-text-centered">
                        <div>
                            <p class="heading">Requested By</p>
                            <p class="title is-size-6"> {{ dataToChild.user_rec_name }} </p>
                        </div>
                    </div>

                    <div class="level-item has-text-centered">

                    </div>


                    <div class="level-item has-text-centered">
<!--                       -->
                    </div>



                </nav>
                 
                <hr>
                <b-table
                        :data="isEmpty ? [] : orderLabRequestDetailFromIDOrder"
                        bordered
                        striped
                        hoverable
                        focusable
                        mobile-cards>


                    <b-table-column   label="ID" v-slot="props">
                        {{ props.row.idpart }}
                    </b-table-column>

                    <b-table-column  label="Descitpion" v-slot="props">
                        {{ props.row.partdecp }}
                    </b-table-column>

                    <b-table-column   label="Amount" v-slot="props">
                        {{ props.row.amount }}
                    </b-table-column>

                    <b-table-column   label="Unit" v-slot="props">
                        {{ props.row.unit_part }}
                    </b-table-column>

                    <b-table-column   label="status" v-slot="props">
                        <b-icon pack="fas"
                                :icon="props.row.status === 'Y' ? 'check' : 'ban'"
                                :type="props.row.status === 'Y' ? 'is-success' : 'is-danger'">
                        </b-icon>
                    </b-table-column>



                    <template slot="empty">
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p>
                                    <b-icon
                                            icon="emoticon-sad"
                                            size="is-large">
                                    </b-icon>
                                </p>
                                <p>Nothing here.</p>
                            </div>
                        </section>
                    </template>
                </b-table>
                <hr>
 
                <!-- {{dat_line_token}} -->
                <p class="is-size-6 has-text-grey-dark mb-5">Requested For <span class="is-size-6 has-text-grey-darker has-text-weight-semibold ml-3">{{dat_line_token.owner_data_fn}}</span>      </p>    
                
                <b-field v-if="dat_line_token.line_token_0"  >
                   <template #label>
                      <p :class="iswantToLine0_Switch ?  'has-text-black-ter' : 'has-text-grey' " >Line notify when publish #1 </p> 
                      <span class="has-text-primary is-italic"><b-switch size="is-small" v-model="iswantToLine0_Switch"></b-switch></span>
                   </template>
                 <p :class="iswantToLine0_Switch ?  'has-text-black-ter' : 'has-text-grey' "> {{dat_line_token.desc_line_token_0}}</p> 
                </b-field>


                <b-field v-if="dat_line_token.line_token_1" >
                   <template #label>
                      <p :class="iswantToLine1_Switch ?  'has-text-black-ter' : 'has-text-grey' " > Line notify when publish #2 </p> 
                      <span class="has-text-primary is-italic"><b-switch size="is-small" v-model="iswantToLine1_Switch"></b-switch></span>
                   </template>
                <p :class="iswantToLine1_Switch ?  'has-text-black-ter' : 'has-text-grey' ">{{dat_line_token.desc_line_token_1}}</p> 
                </b-field>


                <b-field v-if="dat_line_token.line_token_2" >
                   <template #label>
                      <p :class="iswantToLine2_Switch ?  'has-text-black-ter' : 'has-text-grey' " > Line notify when publish #3 </p> 
                      <span class="has-text-primary is-italic"><b-switch size="is-small" v-model="iswantToLine2_Switch"></b-switch></span>
                   </template>
                <p :class="iswantToLine2_Switch ?  'has-text-black-ter' : 'has-text-grey' ">{{dat_line_token.desc_line_token_2}}</p> 
                </b-field>
               

                   
                <hr>



                <nav class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <p class="heading">Add Lab No.</p>
                            <b-button type="is-success"
                                      icon-right="plus"
                                      @click="addLabLN" />
                        </div>

                    </div>
                    <div class="level-right">

                    </div>
                </nav>

                 

                <div>
                    
                    <div v-for="(assignJob,index) in assignJob" :key="assignJob.uid" >
                        <div class="box" style="margin-bottom: 15px">

                                <b-field label="Document">
                                    <b-select placeholder="Select a name"  v-model="docKindSelected[index]">
                                        <option
                                                v-for="docKind in docKind"
                                                :value="docKind.id"
                                                :key="docKind.id">
                                            {{ docKind.name }}
                                        </option>
                                    </b-select>
                                </b-field>





 

                            <nav class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <b-field label="Pathologist"   >

                                            <template #label>

                                                <!-- <b-switch v-model="isSwitchedAssignToPathologist[index]">
                                                 {{ switchedAssignToCaptions(index) }}
                                                </b-switch> -->




                                                    <!-- <b-field>
                                                    <b-radio v-model="radio"
                                                        name="name"
                                                        native-value="Flint">
                                                        Assign to Pathologist
                                                    </b-radio>
                                                    </b-field>


                                                    <b-field>
                                                    <b-radio v-model="radio"
                                                        name="name"
                                                        native-value="Silver">
                                                        Assign to Lab Staff
                                                    </b-radio>
                                                    </b-field>

                                                    <b-field>
                                                    <b-radio v-model="radio"
                                                        name="name"
                                                        native-value="Jack">
                                                        Assign to Parasitologist
                                                    </b-radio>
                                                    </b-field> -->




 <b-tabs  >
            <b-tab-item label="Pathologist">
           
                                            <b-select placeholder="Select a name"   v-model="pathologistSelected[index]" >
                                                <option
                                                        v-for="pathologist in pathologists"
                                                        :value="pathologist.id"
                                                        :key="pathologist.id">
                                                    {{ pathologist.name }} {{ pathologist.surname }}
                                                </option>
                                            </b-select>
            </b-tab-item>
            <b-tab-item label="Lab Staff">
                                           <b-select placeholder="Select a name"  v-model="pathologistSelected[index]" >
                                                <option
                                                        v-for="labstaff in labStaff"
                                                        :value="labstaff.id"
                                                        :key="labstaff.id">
                                                    {{ labstaff.name }} {{ labstaff.surname }}
                                                </option>
                                            </b-select>
            </b-tab-item>
            <b-tab-item label="Parasitologist">
                                            <b-select placeholder="Select a name"   v-model="pathologistSelected[index]" >
                                                <option
                                                        v-for="parasitologist in parasitologists"
                                                        :value="parasitologist.id"
                                                        :key="parasitologist.id">
                                                    {{ parasitologist.name }} {{ parasitologist.surname }}
                                                </option>
                                            </b-select>
            </b-tab-item>
 </b-tabs>



         
                                            </template>

                                   
                                            <!-- <b-select placeholder="Select a name"  v-model="pathologistSelected[index]"  v-if="isSwitchedAssignToPathologist[index]">
                                                <option
                                                        v-for="pathologist in pathologists"
                                                        :value="pathologist.id"
                                                        :key="pathologist.id">
                                                    {{ pathologist.name }} {{ pathologist.surname }}
                                                </option>
                                            </b-select>



                                            <b-select placeholder="Select a name"  v-model="pathologistSelected[index]"  v-if="!isSwitchedAssignToPathologist[index]">
                                                <option
                                                        v-for="labStaffEach in labStaff"
                                                        :value="labStaffEach.id"
                                                        :key="labStaffEach.id">
                                                    {{ labStaffEach.name }} {{ labStaffEach.surname }}
                                                </option>
                                            </b-select> -->







                                        </b-field>
                                    </div>

                                </div>
                                <div class="level-right">
                                    <div class="level-item">
                                        <b-field label="Delete">
                                            <b-button type="is-danger"
                                                      icon-right="delete"
                                                      @click="deleteRow(assignJob.uid)"/>
                                        </b-field>
                                    </div>
                                </div>
                            </nav>


                        </div>




<!--                        <b-field grouped>-->

<!--                            <b-field label="Document">-->
<!--                                <b-select placeholder="Select a name"  v-model="docKindSelected[index]">-->
<!--                                    <option-->
<!--                                            v-for="docKind in docKind"-->
<!--                                            :value="docKind.id"-->
<!--                                            :key="docKind.id">-->
<!--                                        {{ docKind.name }}-->
<!--                                    </option>-->
<!--                                </b-select>-->
<!--                            </b-field>-->



<!--                            <b-field label="Pathologist" v-if="!showStaffRead[index]" >-->
<!--                                <b-select placeholder="Select a name"  v-model="pathologistSelected[index]" :disabled=!docKindSelected[index]>-->
<!--                                    <option-->
<!--                                            v-for="pathologist in pathologists"-->
<!--                                            :value="pathologist.id"-->
<!--                                            :key="pathologist.id">-->
<!--                                        {{ pathologist.name }} {{ pathologist.surname }}-->
<!--                                    </option>-->
<!--                                </b-select>-->
<!--                            </b-field>-->

<!--                            <b-field label="Lab Staff" v-if="showStaffRead[index]">-->
<!--                                <b-select placeholder="Select a name"  v-model="pathologistSelected[index]">-->
<!--                                    <option-->
<!--                                            v-for="labStaffEach in labStaff"-->
<!--                                            :value="labStaffEach.id"-->
<!--                                            :key="labStaffEach.id">-->
<!--                                        {{ labStaffEach.name }} {{ labStaffEach.surname }}-->
<!--                                    </option>-->
<!--                                </b-select>-->
<!--                            </b-field>-->





<!--                            <b-field label="Delete">-->
<!--                                <b-button type="is-danger"-->
<!--                                          icon-right="delete"-->
<!--                                          @click="deleteRow(assignJob.uid)"/>-->
<!--                            </b-field>-->
<!--                        </b-field>-->
                    </div>
                </div>

            </section>
            <footer class="modal-card-foot" style="justify-content: space-between;">

<!--                <nav class="level is-mobile">-->
<!--                    <div class="level-left">-->
<!--                        <div class="level-item">-->
<!--                            <button class="button is-warning">Button</button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="level-right">-->
<!--                        <div class="level-item">-->
<!--                            <button class="button is-warning">Button</button>-->
<!--                        </div>-->
<!--                        <div class="level-item">-->
<!--                            <button class="button is-danger">Button</button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </nav>-->
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <b-button type="is-danger"
                          icon-right="close"
                          @click="closeBtn" >Cancel</b-button>
                &nbsp;&nbsp;&nbsp;

                <b-button type="is-success"
                          icon-right="cloud-upload"
                          @click="saveData" >Save</b-button>

            </footer>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-console */
    import { getBaseURLforBackEnd, customFormatDate,getConfigAxios }  from '@/utils.js'
    import {mapState} from "vuex";
    import { genUUID }  from '@/utils.js'
    import axios from "axios";


    export default {

        name: "AssignedJob",
        computed:{
            ...mapState({
                pathologists : state => state.master_data.pathologists ,
                docKind : state => state.master_data.docKind ,
                labStaff: state => state.master_data.labStaff ,
                parasitologists: state => state.master_data.parasitologists ,
                access_token: state => state.master_data.access_token,
            }),



        },
        created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.closeBtn()
                next(false)
            })
            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
        },
        props:{
            dataToChild : null ,
            isShowAssignedJob : Boolean
        },
        methods:{
            switchedAssignToCaptions:function (index) {
                return this.isSwitchedAssignToPathologist[index] ? 'Assign to Pathologist' : 'Assign to Lab Staff'
            },
            loadDetailOrder(){
                let endPoint = this.dataToChild.patho_job !==1 ? 'orderlabrequestdetailfrom_idorder' : 'orderlabrequestdetailfromidorder_pathoservices'
              
                   const datTo = {
                    "id": this.dataToChild.idlaborder
                   }

                    const vm = this
                    this.isFullScreenSearching = true
                    axios.post(`${getBaseURLforBackEnd()}/api/${endPoint}`,datTo,getConfigAxios())
                        .then(res=>{
                            vm.orderLabRequestDetailFromIDOrder = res.data.dat_used_part
                            vm.dat_line_token =  Object.assign({},res.data.dat_line_token)  
                            vm.isFullScreenSearching = false
                        })
                        .catch(err=>{
                            vm.isFullScreenSearching = false
                            this.$buefy.dialog.alert({
                                title: 'Error',
                                message: `${err.message}`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                        })
             
                 



            },
            closeBtn(){
                this.$emit('close')
            },
            customFormatDateF(dat){
                return customFormatDate(dat)
            },
            addLabLN(){
                // map tree array to compare key index
                // for manage array
                // prepare user input
                // and prepare to keep for backend
                this.assignJob.push({"uid": genUUID(5)});
                this.docKindSelected.push("")
                this.pathologistSelected.push("")
                // this.showStaffRead.push(false)
                this.isSwitchedAssignToPathologist.push(false)
            },
            deleteRow(dat){
                const member = this.assignJob.find( member=> {
                    return member.uid === dat
                })
                const memberIndex = this.assignJob.indexOf(member)

                this.assignJob.splice(memberIndex,1)
                this.docKindSelected.splice(memberIndex,1)
                this.pathologistSelected.splice(memberIndex,1)
                // this.showStaffRead.splice(memberIndex,1)
                this.isSwitchedAssignToPathologist.splice(memberIndex,1)
            },
            checkAllDataEmpty(){
                for(var i=0;i<=this.assignJob.length;i++){
                    if  ( (this.docKindSelected[i] === "")  || (this.pathologistSelected[i] === "") ) {
                        return i
                    }
                }
                return  -1  //
            },
            saveData(){
                // console.log(this.assignJob)
                // console.log(this.docKindSelected)
                // console.log(this.pathologistSelected)

                if (this.assignJob.length>0){
                    if (this.checkAllDataEmpty() === -1){
                       // ok
                       //  console.log("ok")
                       // continue to save

                       
                        const datTo = {
                            "idlaborder": this.dataToChild.idlaborder,
                            "idkindlab":  this.docKindSelected,
                            "assignto":   this.pathologistSelected,
                            "wanttoline_notify_0" : this.iswantToLine0_Switch,
                            "wanttoline_notify_1" : this.iswantToLine1_Switch,
                            "wanttoline_notify_2" : this.iswantToLine2_Switch
                        }

                        // console.log(JSON.stringify(datTo))

                        const vm = this
                        this.isFullScreenSearching = true
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                        axios.post(`${getBaseURLforBackEnd()}/api/createlab_and_assigedjob`,datTo,getConfigAxios())
                            .then((res)=>{
                                    vm.isFullScreenSearching = false
                                    vm.$buefy.dialog.alert({
                                        title: 'Success',
                                        message: `${res.data.msg}`,
                                        confirmText: 'ok'
                                    })
                                    vm.$emit('close')
                            })
                            .catch(err=>{
                                console.log(err)
                                if (err.response && err.response.status === 401) {
                                    vm.$router.push('/login')
                                }
                            })
                            .finally(()=>{
                                vm.isFullScreenSearching = false
                            })








                    }else{
                        // error
                        // console.log("not ok")
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'Some item do not select complete , Pls select Document or Pathologist or Parasitologist !!!',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',

                        })
                    }
                }else{
                   // error
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Do not have any <b>Document</b> and <b>Pathologist</b>',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',

                    })
                }

            },

        },
        data() {
            return {
                isEmpty : false,

                //
                assignJob : [],
                docKindSelected : [],
                pathologistSelected :[],
                //
                orderLabRequestDetailFromIDOrder:[],
                dat_line_token: {},  
                // dat_line_token: {
                //                         "owner_data": 415,
                //                         "owner_data_fn": "ภาคภูมิ บุศยพลากร",
                //                         "line_token_0": null,
                //                         "desc_line_token_0": null,
                //                         "line_token_1": null,
                //                         "desc_line_token_1": null,
                //                         "line_token_2": null,
                //                         "desc_line_token_2": null
                //                     },



                isFullScreenSearching : false ,//

                //showStaffRead : []
                isSwitchedAssignToPathologist : [],

                iswantToLine0_Switch : false,
                iswantToLine1_Switch : false,
                iswantToLine2_Switch : false,
            }
        },
        watch:{
            // docKindSelected:{
            //     immediate : true,
            //     handler: function (arr) {
            //        // console.log(JSON.stringify(val))
            //         for(var i = 0 ; i < arr.length;i++){
            //             if(arr[i]!==""){
            //
            //              const tmpDockind =  this.docKind.find((datDocKind)=>{
            //                    return    datDocKind.id === arr[i]
            //                 })
            //              // tmpDockind.for_staff_read  === true ?  this.showStaffRead[i]  = true  :    this.showStaffRead[i]  = false
            //              tmpDockind.for_staff_read  === true ?  this.isSwitchedAssignToPathologist[i]  = true  :    this.isSwitchedAssignToPathologist[i]  = false
            //             }
            //
            //         }
            //     }
            // },
            isShowAssignedJob:{
                immediate : true,
                handler: function (val) {
                  if(val){
                      // console.log('Assign show '+this.dataToChild.idlaborder)
                      this.loadDetailOrder()
                  }
                }
            }
        }
    }
</script>

<style scoped>

</style>